
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryPack70 as ObiBatteryPack70Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-pack-70.js';
 
 
 

 
 export const ObiBatteryPack70 = createComponent({
   react: React,
   tagName: 'obi-battery-pack-70',
   elementClass: ObiBatteryPack70Element,
   events: {
     
   }
  });
 
 